import { render, staticRenderFns } from "./Balance_general.vue?vue&type=template&id=52b8c73d&lang=pug&"
import script from "./Balance_general.vue?vue&type=script&lang=js&"
export * from "./Balance_general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports